import { useEffect, useRef } from 'react';

const ICON_SIZE = 32;
const DOT_RADIUS = 7;
const DOT_FILL = '#E11D48';
const DOT_STROKE = '#FFFFFF';
const DOT_STROKE_WIDTH = 1.5;

function findIconLink(): HTMLLinkElement | null {
  return document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
}

function drawBadgedFavicon(img: HTMLImageElement): string | null {
  const canvas = document.createElement('canvas');
  canvas.width = ICON_SIZE;
  canvas.height = ICON_SIZE;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  ctx.drawImage(img, 0, 0, ICON_SIZE, ICON_SIZE);

  const cx = ICON_SIZE - DOT_RADIUS - 1;
  const cy = DOT_RADIUS + 1;
  ctx.beginPath();
  ctx.arc(cx, cy, DOT_RADIUS, 0, Math.PI * 2);
  ctx.fillStyle = DOT_FILL;
  ctx.fill();
  ctx.lineWidth = DOT_STROKE_WIDTH;
  ctx.strokeStyle = DOT_STROKE;
  ctx.stroke();

  return canvas.toDataURL('image/png');
}

export function useFaviconBadge(showBadge: boolean) {
  const badgedHrefRef = useRef<string | null>(null);

  useEffect(() => {
    if (!showBadge) return;

    const link = findIconLink();
    if (!link) return;

    const originalHref = link.href;
    let cancelled = false;

    const apply = (dataUrl: string) => {
      if (!cancelled) link.href = dataUrl;
    };

    if (badgedHrefRef.current) {
      apply(badgedHrefRef.current);
    } else {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const dataUrl = drawBadgedFavicon(img);
        if (dataUrl) {
          badgedHrefRef.current = dataUrl;
          apply(dataUrl);
        }
      };
      img.src = originalHref;
    }

    return () => {
      cancelled = true;
      link.href = originalHref;
    };
  }, [showBadge]);
}
